import React from 'react';
import { Form, Col } from 'react-bootstrap';

function FormControl(props) {

    return (
        <Form.Group as={Col} controlId={props.controlId}>
            <Form.Label className="text-headertext">{props.label}</Form.Label>
            <Form.Control
                className="text-subtext"
                required={props.required}
                value={props.value}
                onChange={e => props.onChange(e.target.value)}
                type={props.type}
                placeholder={props.placeholder} />
        </Form.Group>
    );

}

export default FormControl;